<template>
    <div class="container-fluid bg-greenpoint-light-v1 mb-4">
        <div class="row justify-content-center">
            <div class="col-10">
                <div class="row">
                    <div class="col-md-8 h-bar">
                        <h2 class="title-bar text-center">{{ title }}</h2>
                    </div>
                    <div class="col-md-4 h-bar-1">
                        <a  @click="btn_ayahuasca = !btn_ayahuasca" class="btn btn-outline-dark rounded-0 subtitle fw-light">
                            {{ subtitle }}
                        </a>
                    </div>
                </div>
            </div>

            <!--contenido-->
            <div v-show="btn_ayahuasca">
                <pre>
                    content
                </pre>
            </div>

        </div>
    </div>
</template>
<script>
import {ref} from "vue"


export default{
    props:['title','subtitle','categories'],

    setup(){
        const btn_ayahuasca = ref(false)

        return {btn_ayahuasca};
    }
}
</script>